// extracted by mini-css-extract-plugin
export default {"heading":"success_heading__KBiGy","body":"success_body__VOBb7"};